import { type CSSProperties, type MouseEventHandler } from 'react';
import TagManager from 'react-gtm-module';
import { GoogleEvents } from '@/features/googleEvents';
import type { Coordinates } from './types';
import classes from './ContextMenu.module.css';

const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
  e.stopPropagation();
  TagManager.dataLayer({
    dataLayer: {
      event: GoogleEvents.openGmapsLink,
    },
  });
};

interface ContextMenuProps {
  coordinates: Coordinates;
}

export const ContextMenu = ({ coordinates }: ContextMenuProps) => {
  const { lng, lat, x, y } = coordinates;
  const positionVars = {
    '--cm-x': `${x}px`,
    '--cm-y': `${y}px`,
  } as CSSProperties;

  return (
    <div className={classes.container} style={positionVars}>
      <a
        id="location-link"
        onClick={handleClick}
        className={classes.link}
        href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}
        target="_blank"
        rel="noreferrer"
      >
        Open in Google Maps
      </a>
    </div>
  );
};
